import React from 'react';
import { Label } from '@/components/client/Label/Label';
import { Icons } from '@/components/icons';
import Image from 'next/image';
import image1 from '@/public/images/about_us/expirience-1.webp';
import image2 from '@/public/images/about_us/expirience-2.webp';

const Card = ({ list, label, title, description }) => {
  return (
    <div className="px-5 py-12">
      <Label label={label} />
      <h4 className="mb-4 mt-8 text-left text-4xl font-semibold md:text-5xl">
        {title}
      </h4>
      <p className="mb-8 text-left text-base md:text-lg">{description}</p>
      <ul>
        {list.map((item) => (
          <li className="mb-4 flex items-center gap-4" key={item.title}>
            <Icons.checkIcon />
            <p className="text-left">{item.title}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const ExpirienseSection = () => {
  return (
    <div className="flex flex-col justify-between gap-8 md:flex-row">
      <div className="flex flex-col">
        <div>
          <Card
            label={'Our Experience'}
            title={'The top choice for any home needs '}
            description={
              'We built our company on honesty and integrity, relying on minimal advertising and strong customer loyalty. Quality work and excellent customer service are the keys to our success.'
            }
            list={[
              { title: 'Over 20 years of experience ' },
              { title: 'Reasonable price ' },
              { title: '100% satisfaction guarantee' },
              { title: 'Excellent customer service' },
            ]}
          />
        </div>
        <div>
          <Image src={image1} alt="Experience Image" layout="responsive" />
        </div>
      </div>
      <div className="flex flex-col">
        <div className="mb-6">
          <Image src={image2} alt="Experience Image" layout="responsive" />
        </div>
        <div>
          <Card
            label={'Our Services'}
            title={'Integrity in everything we do '}
            description={
              'At Tytum, we work to provide the best service experience our customers will ever have and make our community a better place to live and work.'
            }
            list={[
              { title: 'Full service experience ' },
              { title: 'Same-Day Service Available ' },
              { title: 'Fully licensed in California ' },
              { title: 'Certified and Experienced Technicians' },
            ]}
          />
        </div>
      </div>
    </div>
  );
};
